import { Code, ConnectError, type Client } from "@connectrpc/connect";
import type { PaginationArguments, PaginationPageInfo } from "#gen/common/v1/pagination_pb.js";
import { StatusService, type Run, type RunFilter } from "#gen/status/v1/status_pb.js";
import { createClient, type ClientOptions } from "#lib/api/api.js";
import { handleError } from "#lib/api/error.js";
import { PUBLIC_URLS } from "#lib/url.js";

export interface WorkflowRunList {
	runs: Run[];
	pageInfo?: PaginationPageInfo;
}

export class StatusClient {
	private client: Client<typeof StatusService>;

	constructor(options?: () => ClientOptions) {
		this.client = createClient(PUBLIC_URLS.status || "/", StatusService, options);
	}

	async listWorkflowRuns(orgId: string, filter?: RunFilter, pagination?: PaginationArguments): Promise<WorkflowRunList> {
		try {
			const res = await this.client.listWorkflowRuns({
				orgId,
				filter,
				pagination,
			});
			return res;
		} catch (e) {
			if (e instanceof ConnectError && e.code == Code.NotFound) {
				return { runs: [] };
			}
			throw handleError(e);
		}
	}
}
